// eslint-disable-next-line arrow-body-style
export const escapeWord = (array: string[]): string[] => {
  return array.map((str) => {
    if (str.length !== 1) return str
    return str.replace(/[\\x00-\\x1F\\x7F-\\x9F]/g, (match) => `\\${match}`)
  })
}

// eslint-disable-next-line arrow-body-style
export const compile = (conditions: string[], isAnd = true): RegExp => {
  let rx
  if (isAnd) {
    const joinAnd = (arr: string[]) => `^(?=[\\s\\S]*${escapeWord(arr).join(')(?=[\\s\\S]*')})`
    rx = joinAnd(conditions).replace(/=\[\\s\\S\]\*-/g, '![\\s\\S]*')
  } else {
    const joinOr = (arr: string[]) => `^(?=[\\s\\S]*(${escapeWord(arr).join('|')}))`
    rx = joinOr(conditions).replace(/=\[\\s\\S\]\*-/g, '![\\s\\S]*')
  }
  return new RegExp(rx)
}
